import React, {useContext} from "react";
import {Grid, Mui} from "@leap4/frontend";
import {PublisherLoginContext} from "./PublisherLoginContex";
import {PartnerContainer} from "./AddEditPL/Partners.container";

const {TextField, Typography} = Mui;

export interface IDetailsFormProps {
    mode: "create" | "edit"
}



const DetailsForm = (props: IDetailsFormProps) => {
    const {publisherLogin, setPublisherLogin} = useContext(PublisherLoginContext);

    return (
        <>
            <Grid margin={"10px"}>
                <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5" >
                    PUBLISHER LOGINS
                </Typography>
            </Grid>
            <Grid container gap={"10px"}>
            {(publisherLogin?.advertiserName + ' - ' + publisherLogin?.publisherName) && <Grid item  width={"100%"}>
                <TextField fullWidth label={"Advertiser - Publisher"} disabled value={(publisherLogin?.advertiserName + ' - ' + publisherLogin?.publisherName)}/>
            </Grid>}
                <Grid item width='70%'>
                </Grid>
            </Grid>
            <Grid margin={"20px"} item width='95%'>
            <PartnerContainer
                currentPublisherLogin={publisherLogin}
            />
            </Grid>
        </>
    )
}
export {DetailsForm}


